import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import { ClientSecretInput } from "@arcadeai/design-system/components/ui/molecules/client-secret-field";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { UseFormReturn } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

type Props = {
  form: UseFormReturn<AuthProvider>;
  canUpdate: boolean;
  oauth?: { oauth2: { client_secret: { exists?: boolean } } };
};

export const ClientSecretField = ({ form, canUpdate, oauth }: Props) => {
  const isEditing = !!oauth;

  return (
    <FormField
      control={form.control}
      name="oauth2.client_secret"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            <span>Client Secret</span>
            {!isEditing && <span className="text-destructive">*</span>}
            {!!(isEditing && canUpdate) && (
              <Badge className="text-xs" variant="outline">
                Optional - Leave empty to keep current
              </Badge>
            )}
          </FormLabel>
          <FormControl>
            <ClientSecretInput
              {...field}
              disabled={!canUpdate}
              mode={isEditing ? "rotate" : "create"}
              secretIsSet={oauth?.oauth2?.client_secret?.exists ?? false}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
